import React from "react";

interface SuccessProps {
    emailAddress: string;
    onRetry: ()=> void;
}

const SendEmailConfirmationSuccess: React.FC<SuccessProps> = ({ emailAddress, onRetry }) => {

    return (
        <div className="row">
            <div className="col-8" id="email_confirmation_el">
                <div className="row text-left">
                    <div className="col-12 mb-5">
                        <div className="header">Send Confirm Registration Email</div>
                        <div className="status-box-success">Confirm registration email successfully sent.</div>
                    </div>
                    <div className="col-12 mb-3">
                        <h5 className="sub-header mb-2">Next Steps</h5>
                        <p>
                            We have sent you an email to <b>{emailAddress}</b> with the confirm registration link. Please click on the
                            link in the email to confirm your registration with Foundations.
                        </p>
                    </div>
                    <div className="col-12">
                        If you do not receive the email within 15 minutes, please check your spam/junk folder first, then{" "}
                        <a 
                            href="#send-email-confirmation" 
                            onClick={onRetry}>
                            try again.
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SendEmailConfirmationSuccess;
